import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';

// Generic donut for a small categorical breakdown (e.g. device category).
// `items`: [{ name, value }]. Colors cycle through the brand palette.
const PALETTE = ['#00205C', '#1FA9C3', '#FFAE1E', '#38A169', '#805AD5', '#E53E3E'];

export default function AnalyticsPie({ title, items }) {
  const slices = (items || []).filter((i) => i.value > 0);
  const total = slices.reduce((sum, i) => sum + i.value, 0);

  if (total === 0) {
    return (
      <div className="chart-card">
        <div className="chart-card__title">{title}</div>
        <div className="chart-card__empty">No data yet</div>
      </div>
    );
  }

  return (
    <div className="chart-card">
      <div className="chart-card__title">{title}</div>
      <div className="chart-card__body">
        <ResponsiveContainer width="100%" height={200}>
          <PieChart>
            <Pie
              data={slices}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              innerRadius={45}
              outerRadius={80}
              stroke="#fff"
              strokeWidth={1}
              isAnimationActive={false}
              label={({ percent }) => (percent >= 0.05 ? `${Math.round(percent * 100)}%` : '')}
              labelLine={false}
            >
              {slices.map((entry, i) => (
                <Cell key={entry.name} fill={PALETTE[i % PALETTE.length]} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [value, name]}
              contentStyle={{ fontSize: 12, borderRadius: 6, border: '1px solid #E2E8F0' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-card__legend">
        {slices.map((item, i) => (
          <div key={item.name} className="chart-legend__row">
            <span
              className="chart-legend__swatch"
              style={{ background: PALETTE[i % PALETTE.length] }}
              aria-hidden="true"
            />
            <span className="chart-legend__label">{item.name}</span>
            <span className="chart-legend__stats">
              {item.value} · {Math.round((item.value / total) * 100)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
